package it.neckar.lizergy.model.state

import it.neckar.open.formatting.humanizedDate
import it.neckar.open.i18n.I18nConfiguration
import it.neckar.open.unit.si.ms
import it.neckar.processStates.ProcessStatePhase

/**
 * Represents the current process state
 */
interface ProcessStates {
  /**
   * The phase of this process state.
   */
  val inPhase: ProcessStatePhase

  fun format(i18nConfiguration: I18nConfiguration): String

  fun formatDate(date: @ms Double, i18nConfiguration: I18nConfiguration): String {
    return humanizedDate(date, i18nConfiguration)
  }

  fun formatWithDate(date: @ms Double, i18nConfiguration: I18nConfiguration): String {
    return "${format(i18nConfiguration)} ${formatDate(date, i18nConfiguration)}".trim()
  }
}
